import React from 'react';
import Dialog from 'Components/DesignSystem/Dialog/Dialog';
import Button from 'Components/DesignSystem/Button/Button';
import Typography from 'Components/DesignSystem/Typography/Typography';

type ConfirmDialogProps = {
    id: string;
    title: string;
    message: string;
    onClose: () => void;
    onConfirm: () => void;
}

/**
 * The ISR Yes/No confirm, on a DS Dialog.
 *
 * It was a hand-rolled `tw-fixed tw-inset-0` overlay — no focus trap, no Escape, no
 * `aria-modal`, and its buttons wore `samll-outline-btn` (sic) and `small-filled-btn`.
 * Reached from the filter block, where switching Single/Multiple Category warns that
 * existing filters will be cleared.
 */
const ConfirmDialog = ({ id, title, message, onClose, onConfirm }: ConfirmDialogProps) => (
    <Dialog
        isOpen
        onClose={onClose}
        title={title}
        data-testid={id}
        footer={(
            <div className="tw-flex tw-gap-2 tw-justify-end">
                <Button
                    id={`${id}-cancel-btn`}
                    data-testid="components-confirmdialog-button-2"
                    variant="secondary"
                    onClick={onClose}
                >
                    No
                </Button>
                <Button
                    id={`${id}-confirm-btn`}
                    data-testid="components-confirmdialog-button-3"
                    variant="primary"
                    onClick={onConfirm}
                >
                    Yes
                </Button>
            </div>
        )}
    >
        <Typography variant="body-primary" className="tw-text-ink-secondary">
            {message}
        </Typography>
    </Dialog>
);

export default ConfirmDialog;
